import { AlertTriangle, CheckCircle2, Circle, Loader2, XCircle } from 'lucide-react';

const stepIcon = (sc, graded, passed) => {
    if (graded) return passed ? CheckCircle2 : XCircle;
    if (sc.status === 'grading') return sc.grading_failed ? AlertTriangle : Loader2;
    return Circle;
};

export const ScenarioStepper = ({ scenarios, currentIndex, passingScore }) => (
    <ol className="flex flex-col gap-2" data-testid="eeoc-stepper">
        {scenarios.map((sc, i) => {
            const graded = sc.status === 'graded';
            const passed = graded && sc.score >= passingScore;
            const spinning = sc.status === 'grading' && !sc.grading_failed;
            const Icon = stepIcon(sc, graded, passed);
            const color = graded ? (passed ? 'text-emerald-600' : 'text-red-600') : sc.grading_failed ? 'text-amber-500' : 'text-muted-foreground';
            return (
                <li
                    key={sc.scenario_id}
                    className={`flex items-center gap-3 rounded-xl border px-3 py-2.5 transition-colors ${
                        i === currentIndex ? 'border-sky-400 bg-sky-500/5' : 'border-border'
                    }`}
                    data-testid={`eeoc-step-${i}`}
                >
                    <Icon className={`h-4 w-4 shrink-0 ${color} ${spinning ? 'animate-spin' : ''}`} />
                    <div className="min-w-0 flex-1">
                        <p className="text-[11px] uppercase tracking-wide text-muted-foreground">Scenario {i + 1}</p>
                        <p className="truncate text-sm font-medium">{sc.scenario.title}</p>
                    </div>
                    {graded && <span className="text-sm font-semibold tabular-nums">{sc.score}</span>}
                </li>
            );
        })}
    </ol>
);
